import { useQuery } from "@tanstack/react-query";
import { getAllCloseReasons } from "@coworker/apprestructured/src/task-management/services/close-reasons.service";

export function useAllCloseReasons() {
  return useQuery({
    queryKey: ["close-reasons"],
    queryFn: getAllCloseReasons,
    staleTime: Infinity,
  });
}
